const controllerDateFormats = [
    'MM/DD/YYYY',
    'DD/MM/YYYY',
    'YYYY-MM-DD',
    'DD-MMM-YYYY',
    'MMMM-D-YYYY',
];

module.exports = {
    controllerDateFormats,
};
